/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamsConnectionStatus
 */
export interface TeamsConnectionStatus {
    /**
     * 
     * @type {boolean}
     * @memberof TeamsConnectionStatus
     */
    ok: boolean;
    /**
     * 
     * @type {string}
     * @memberof TeamsConnectionStatus
     */
    team: string;
}

export function TeamsConnectionStatusFromJSON(json: any): TeamsConnectionStatus {
    return TeamsConnectionStatusFromJSONTyped(json, false);
}

export function TeamsConnectionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamsConnectionStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ok': json['ok'],
        'team': json['team'],
    };
}

export function TeamsConnectionStatusToJSON(value?: TeamsConnectionStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ok': value.ok,
        'team': value.team,
    };
}


